const UserHelp = () =>{
    return (
        <>  
<div className="top-bar clearfix">
        <div className="row">
          <div className="col-xs-12">
            <h2> User Manual  </h2>
          </div>
        </div>
      </div>

      <div className="container-fluid p-3">
      <div class="card mb-3 shadow no-border border-0">
        <div class="card-body" >
  
<div class="uk-section uk-section-small uk-padding-remove-bottom section-content" style={{ padding:"10px 400px 0px 400px"}}>
  <div class="uk-container uk-position-relative">
    <div class="uk-grid">
      <div class="uk-width-3-4@m">
        <article class="uk-article">
        
          <p style={{ fontSize:"22px", fontWeight:"bold"}}>How to login to AVT?</p>
			<br/>
      <p style={{ width:"60%"}}>Click/ Enter the below URL in your browser. 
          <br/>To login to AVT click on the ‘Sign In’ button available on the top-right side of AVT page. 
          <br/>URL: <a href="http://avtbharat.com/" class="url-link" target="_blank">http://avtbharat.com/</a> </p>
          <p style={{textAlign:"left"}}>
         <img src="./img/1.png"  alt="How to login to AVT?"  width="60%" class="zoom"/>  </p>
         <p style={{ width:"60%"}}>On login screen, please enter <strong>‘User Name’</strong>, <strong>‘Password’</strong> and click on the Login button. </p>
          <p> <img src="./img/2.png"  alt="How to login to AVT?" class="zoom" width="60%"/>  </p>
          <p style={{ width:"60%"}}>After a successful login to AVT, the AVT dashboard page will open. 
          <br/>It will show a map/ location view of the vehicle’s movements.
          <br/> User can also check the vehicle details based on the vehicle’s status (Moving, Idle, Parked, Not Working) available on the top right side.
           <br/> On the left side of dashboard, the menu’s name and AVT logo are visible.</p>
          <p> <img src="./img/3.png" class="zoom" alt="How to login to AVT?" width="60%"/> </p>
			    <p style={{ fontSize:"22px", fontWeight:"bold"}}>How to logout from AVT?</p>
          <br/>
          <p style={{ width:"60%"}}>User can logout from the AVT by clicking on the <strong>‘SignOut’</strong> button available on the top-right side.</p>
          <p> 
          <img src="./img/4.png" class="zoom" alt="How to logout from AVT?" width="60%"/></p>          
          <p style={{ fontSize:"22px", fontWeight:"bold"}}>How to add a new vehicle?</p>
          <br/>
          <p>Go to the ‘Vehicles’ menu from the left side menu bar of AVT page.</p>
          <p> 
          <img src="./img/5.png" class="zoom" alt="How to add a new vehicle?" width="60%"/> </p>
          <p style={{ width:"60%"}}>The Vehicles page will display the entire vehicle list.
          <br/> you have entered so far into the database. 
          <br/>Please click on the “<strong>New</strong>” button to add a new vehicle in AVT.</p>
          <p> 
          <img src="./img/6.png" class="zoom" alt="How to add a new vehicle?" width="60%"/> </p>
          <p style={{ width:"60%"}}>On the Create Vehicles page, please enter all the mandatory fields, which are highlighted with red asterisk mark (*) beside every label.
            <br/> In the ‘IMEI#’ dropdown, the list of purchased ‘AVT Devices’ will come to assign/map the AVT device/IMEI# to a Vehicle.
            <br/> In the ‘Driver’ dropdown the list of drivers will come to assign/map the driver to a vehicle/ AVT device. 
            <br/>You can map a device/ IMEI# with the vehicle by selecting the device from IMEI# dropdown. 
            <br/>You can map a driver with the vehicle by selecting the driver’s name from driver dropdown.
            <br/> After entering all the mandatory information, please click on the Save button. 
            <br/>The Save button will save this new vehicle record to the database.</p>
          <p><img src="./img/7.png" class="zoom" alt="How to add a new vehicle?" width="60%"/>  </p>
          <p style={{ width:"60%"}}> To View/ Edit / Delete the existing vehicles.
          <br/> click on the View/ Edit / Delete button available under the ‘Action’ column on the right side of vehicle list.</p>
          <p><img src="./img/8.png" class="zoom" alt="How to add a new vehicle?" width="60%"/>  </p>
			    <p style={{ fontSize:"22px", fontWeight:"bold"}}>How to add a new driver?</p>
          <br/>
          <p style={{ width:"60%"}}> Go to the ‘Drivers’ menu from the left side menu bar of AVT page.</p>
          <p> 
          <img src="./img/9.png" class="zoom" alt="How to add a new driver?"  width="60%"/>  </p>
          <p>The Drivers page will display the entire driver list.
          <br/> you have entered so far into the database. 
          <br/>Please click on the “New” button to add a new driver in AVT.</p>
          <p> 
          <img src="./img/10.png" class="zoom" alt="How to add a new driver?" width="60%"/>  </p>
          <p style={{ width:"60%"}}>On the Create Drivers page.
          <br/>please enter all the mandatory fields, which are highlighted with red asterisk mark (*) beside every label. 
          <br/>After entering all the mandatory information, please click on the Save button. 
          <br/>The Save button will save this new driver record to the database.</p>
          <p> 
          <img src="./img/11.png" class="zoom" alt="How to add a new driver?" width="60%"/> </p>
          <p style={{ width:"60%"}}>To View/ Edit / Delete the existing drivers.
          <br/>click on the View/ Edit / Delete button available under the ‘Action’ column on the right side of Driver list.</p>
          <p> 
          <img src="./img/12.png" class="zoom" alt="How to add a new driver?" width="60%"/>  </p>
          <p style={{ fontSize:"22px", fontWeight:"bold"}}>How to view the device details?</p>
          <br/>
          <p style={{ width:"60%"}}>Go to the ‘Devices’ menu from the left side menu bar of AVT page. 
          <br/>The ‘Devices’ page will display the device list you have assigned/ purchased.</p>
			
          <p> 
          <img src="./img/13.png" class="zoom" alt="How to view the device details?" width="60%"/>  </p>
          <p style={{ width:"60%"}}>To view all other details of the device, click on the view button under action.</p>
			
          <p> 
          <img src="./img/14.png" class="zoom" alt="How to view the device details?" width="60%"/>  </p>					
          <p style={{ fontSize:"22px", fontWeight:"bold"}}>How to track a device/ vehicle?</p>
          <br/>
			
			<p>There are two ways to track the device/ vehicle: -</p>
			<p style={{ width:"60%"}}><strong>(i)</strong> You can track a vehicle from the dashboard menu. 
      <br/>All the vehicle will show in the Map/location view, and the user can also filter status wise (i.e. Moving/ Idle/ Parked/ No Network).</p>
			
			<p>  
      <img src="./img/15.png" class="zoom" alt="How to track a device/ vehicle?" width="60%"/>  </p>
			
			<p style={{ width:"60%"}}><strong>(ii)</strong> User can also track a particular device/ vehicle from the ‘map’ icon available in the Device and Vehicle menus.</p>
			
			<p> 
      <img src="./img/16.png" class="zoom" alt="How to track a device/ vehicle?" width="60%"/>  </p>
			
		   <p style={{ fontSize:"22px", fontWeight:"bold"}}>How to change my password?</p>
          <br/>
          <p style={{ width:"60%"}}>User can change his password by clicking on the name dropdown available on the top-right side of the AVT Page</p>
			
			<p> 
      <img src="./img/17.png" class="zoom" alt="How to track a device/ vehicle?" width="60%"/> </p>					
          <p style={{ fontSize:"22px", fontWeight:"bold"}}>How to set/add a new alert?</p>
          <br/>
			<p>Go to the ‘Alert Settings’ menu from the left side menu bar of AVT page.</p>
			<p> 
      <img src="./img/18.png" class="zoom" alt="How to set/add a new alert?" width="60%"/>  </p>
			<p style={{ width:"60%"}}>The ‘Alert Settings’ page will display the entire alerts settings.
      <br/>you have entered so far into the database. Please click on the “Settings” button to add a new alert setting in AVT.</p>
			<p> 
      <img src="./img/19.png" class="zoom" alt="How to set/add a new alert?" width="60%"/> </p>
			<p style={{ width:"60%"}}>On the Settings page.
      <br/>please enter all the mandatory fields, which are highlighted with red asterisk mark (*) beside every label.
      <br/>After entering all the mandatory information, please click on the Save button. 
      <br/>The Save button will save this new alert setting to the database.</p>
			<p> 
      <img src="./img/20.png" class="zoom" alt="How to set/add a new alert?" width="60%"/>  </p>
      <p style={{ width:"60%"}}>To View/ Edit the existing alert setting.
      <br/>click on the View/ Edit / Delete button available under the ‘Action’ column on the right side of the vehicle list.</p>
			<p> 
      <img src="./img/21.png" class="zoom" alt="How to set/add a new alert?" width="60%"/>  </p>
			<p style={{ fontSize:"22px", fontWeight:"bold"}}>How to view the alerts for a vehicle?</p>
          <br/>
          <p style={{ width:"60%"}}>To view the alert messages received in the system.
      <br/>go to the ‘Alerts’ menu from the left side menu bar of AVT page.
      <br/>The ‘Alerts’ page will display the entire alert messages received in the system. 
      <br/>System will send the alert messages based on the ‘Alert Settings’ saved by the user in AVT  ‘Alert Settings’ menu. 
      <br/>You can search for alerts based on vehicle or alert type from the search option.</p>
			<p> 
      <img src="./img/22.png" class="zoom" alt="How to view the alerts for a vehicle?" width="60%"/>  </p>		   
            <p style={{ fontSize:"22px", fontWeight:"bold"}}>How to view the history of a vehicle?</p>
            <br/>
            <p style={{ width:"60%"}}>Go to the ‘History’ menu from the left side menu bar of AVT page. 
        <br/>Select a vehicle from the ‘Vehicle#’ dropdown value and click on the search button to view history of the selected vehicle.</p>
				<p> 
        <img src="./img/23.png" class="zoom" alt="How to view the history of a vehicle?" width="60%"/>  </p>
				<p style={{ width:"60%"}}>The history page will show the trip/ movements history of vehicle, along with the date/ time/ distance/ speed/ locations details.</p>
				<p>  
        <img src="./img/24.png" class="zoom" alt="How to view the history of a vehicle?" width="60%" />  </p>
          
			
			
        </article>
      </div>
      
    </div>
  </div>
</div>
       
        </div> </div>
        </div>
</>
);}
export default UserHelp;